import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-color",
  "use": "icon-color-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-color\">\n  <path d=\"M512 64c-247.4 0-448 200.6-448 448s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64z m0 820c-205.4 0-372-166.6-372-372 0-89 31.3-170.8 83.5-234.8l522.3 522.3C681.8 850.7 600 882 512 884z m288.5-137.2L278.2 224.5C342.2 172.3 424 141 512 141c205.4 0 372 166.6 372 372 0 88-31.3 169.8-83.5 233.8z\" fill=\"currentColor\" p-id=\"19427\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/color.svg
// module id = fnP5
// module chunks = 117